import * as React from "react"
import { IButtonProps } from "./buttons.interface"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { SecondaryButton } from "./secondary"
import { useTranslation } from "react-i18next"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"

const _VideoButton: React.FC<IButtonProps> = props => {
  const { isMobile, text, isActive, ...otherProps } = props
  const roomStyles = useRecoilValue(brandingSelector)
  const { t } = useTranslation()
  const { isTablet } = useRecoilValue(viewDependingLayoutAtom)
  return (
    <SecondaryButton
      text={t(text)}
      isMobile={isMobile && !isTablet}
      fontSize={"0.85rem"}
      width="auto"
      bg={
        isActive
          ? roomStyles?.secondaryAccessButtonSelectedColor
          : roomStyles?.secondaryAccessButtonBackgroundColor ?? "#1AC541"
      }
      textColor={
        isActive
          ? roomStyles?.secondaryAccessButtonSelectedTextColor
          : roomStyles?.secondaryAccessButtonTextColor ?? "#FFFFFF"
      }
      height={isMobile ? "25px" : "2rem"}
      {...otherProps}
    />
  )
}

export const VideoButton = React.memo(_VideoButton)
